import SidePanelView from "./sidePanelView.js";
import { formatPrice } from "../helpers.js";
import { CART_FREE_DELIVERY_THRESHOLD } from "../config.js";

class MiniCartView extends SidePanelView {
  _actionBtn = document.querySelector(".btn-header-panel-cart");

  addHandlerRemoveCartEntry(handler) {
    document.querySelectorAll(".btn-panel-remove").forEach((item) => {
      item.addEventListener("click", function () {
        handler(item.dataset.entryNumber);
      });
    });
  }

  addHandlerCheckoutModal(handler) {
    document
      .querySelector(".btn-checkout")
      ?.addEventListener("click", function () {
        handler();
      });
  }

  _extractItems(data) {
    return data.entries;
  }

  _generateItemMarkup(entry) {
    const item = entry.item;
    return `
      <li class="side-panel-list-item large">
        <div class="side-panel-list-item-content">
          <div class="ai-image">
            <picture>
              <source
                srcset="${item.image.small.webp}"
                type="image/webp"
              />
              <source
                srcset="${item.image.small.jpg}"
                type="image/jpg"
              />
              <img
                src="${item.image.small.webp}"
                class="side-panel-item-img"
                alt="Picture of ${item.name} in cart entry"
              />
            </picture>
            <span class="ai-label" title="This image was generated with AI">AI</span>
          </div>
          <div class="side-panel-item-textbox">
            <p class="side-panel-item-text">${item.name}</p>
            ${this.#generateChildEntriesListMarkup(entry.childEntries)}
            <p class="side-panel-item-price">
              ${formatPrice(entry.price)}
            </p>
          </div>
        </div>
        <button class="btn btn-panel-remove" data-entry-number="${
          entry.entryNumber
        }">
          <i class="icon ph ph-trash-simple"></i>
        </button>
      </li>
    `;
  }

  #generateChildEntriesListMarkup(childEntries) {
    return `
      <ul class="side-panel-item-children">
        ${childEntries
          .map((childEntry) => {
            return `
            <li class="side-panel-item-child">
              &ndash;&nbsp;${childEntry.item.name}
            </li>
          `;
          })
          .join("")}
      </ul>
    `;
  }

  _generatePanelBottomMarkup(cart) {
    if (cart.totalPrice === 0) {
      return "";
    }
    return `
      <div class="side-panel-textbox">
        <div class="side-panel-header-icon background">
          <i class="ph ph-shopping-cart-simple"></i>
        </div>
        <p class="side-panel-price-text">
          <span>Total price:</span>
          <span>${formatPrice(cart.totalPrice)}</span>
        </p>
        <p class="side-panel-price-text">
          <span>Delivery cost*:</span>
          <span>${formatPrice(cart.deliveryCost)}</span>
        </p>
        <p class="side-panel-price-text total">
          <span>Total cost:</span>
          <span>${formatPrice(cart.totalCost)}</span>
        </p>
        <p class="side-panel-disclaimer">
          *Free delivery for a total price of more than ${formatPrice(
            CART_FREE_DELIVERY_THRESHOLD
          )}
        </p>
      </div>
    `;
  }

  _generatePanelActions(cart) {
    if (cart.totalPrice === 0) {
      return "";
    }
    return `
      <div class="side-panel-actions">
        <button class="btn btn-primary btn-checkout">Checkout</button>
      </div>
    `;
  }

  _generateEmptyListMarkup() {
    return `
      <div class="side-panel-textbox">
        <div class="side-panel-header-icon">
          <i class="ph ph-shopping-cart-simple"></i>
        </div>
        <p class="side-panel-empty-text">
          Add your <span class="side-panel-text-emphasize cart">Hero</span> meal here!
        </p>
      </div>
    `;
  }
}

export default new MiniCartView();
